import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
    },
    {
        path: 'intro',
        loadComponent: () => import('./pages/intro/intro.page').then(m => m.IntroPage)
    },
    {
        path: 'regulations',
        loadComponent: () => import('./pages/regulations-acceptance/regulations-acceptance.page').then(m => m.RegulationsAcceptancePage)
    },
    {
        path: 'street-selector',
        loadComponent: () => import('./pages/street-selector-page/street-selector.page').then(m => m.StreetSelectorPage)
    },
    {
        path: 'number-selector',
        loadComponent: () => import('./pages/number-selector-page/number-selector.page').then(m => m.NumberSelectorPage)
    },
    {
        path: 'city-selector',
        loadComponent: () => import('./pages/city-selector-page/city-selector.page').then(m => m.CitySelectorPage)
    }
];

